import { useState } from 'react';
import UserService from '../Services/UserService';
import type { PartialProfessionalProfileUpdate, UserRead } from '../../Types/schema-helpers';


export const useUserMeQualifications = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataError, setDataError] = useState<Error | null>(null);

  /**
   * Updates user qualifications by passing partial profile update payload to UserService.
   */
  const updateQualifications = async (qualifications: any[]): Promise<UserRead> => {
    setLoading(true);
    setDataError(null);
    try {
      const payload: PartialProfessionalProfileUpdate = {
        qualifications,
      };
      const updatedUser = await UserService.updateProInfoByPro(payload);
      return updatedUser;
    } catch (err: any) {
      console.error("Failed to update qualifications", err);
      setDataError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    isDataLoading: loading,
    dataError,
    updateQualifications,
  };
};